import { FC } from "react"
import { ReturnItem } from "../../../app/reducers/analyticsSlice"
import { DataTable, type DataTableColumn } from "../../DataTable/DataTable"

type ReturnsSectionProps = { items: ReturnItem[] }

type ReturnRow = ReturnItem & { _index: number; _maxRate: number }

const columns: DataTableColumn<ReturnRow>[] = [
  { key: "_index", header: "#", cell: (row) => row._index },
  {
    key: "article",
    header: "Артикул",
    cell: (item) =>
      item.article.length > 40 ? item.article.slice(0, 40) + "…" : item.article,
  },
  { key: "name", header: "Категория" },
  { key: "salesCount", header: "Продажи" },
  { key: "returnsCount", header: "Возвраты" },
  {
    key: "returnRate",
    header: "Доля возвратов",
    cell: (item) => (
      <div className="return-rate-bar">
        <div
          className="return-rate-fill"
          style={{
            width: `${(item.returnRate / Math.max(item._maxRate, 1)) * 120}px`,
          }}
        />
        <span>{item.returnRate}%</span>
      </div>
    ),
  },
]

export const ReturnsSection: FC<ReturnsSectionProps> = ({ items }) => {
  const maxRate = Math.max(...items.map((i) => i.returnRate), 1)

  return (
    <div className="chart-wrap">
      <div className="chart-title">Анализ возвратов (top-50)</div>
      {items.length === 0 ? (
        <div className="analytics-empty">Возвратов за период не найдено</div>
      ) : (
        <div className="analytics-table-wrap">
          <DataTable
            columns={columns}
            data={items.map((item, i) => ({
              ...item,
              _index: i + 1,
              _maxRate: maxRate,
            }))}
            rowKey={(item) => item.nmId}
            variant="ghost"
            size="2"
          />
        </div>
      )}
    </div>
  )
}
